// extracted by mini-css-extract-plugin
export default {"value":"value--YAIw8","html":"html--cFkYB"};